/**
 * Reduer for email templates
 */

import get from 'lodash/get';

import {
  FETCH_CREDIT_TRANSACTIONS,
  UPDATE_CREDIT_TRANSACTION,
  ADD_CREDIT_TRANSACTION,
  RESET_CREDIT_REDUCER,
} from '../actions/actionTypes';
import { updateItemInItems } from '../../utils';

const initialState = {
  transactions: [],
  isLoading: false,
  hasUpdate: false,
  page: 1,
  limit: 10
};

export const transactionsSelector = (state) =>
  get(state, 'creditTransactions', []);
const transactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CREDIT_TRANSACTIONS:
      return { ...state, ...action.data };
    case UPDATE_CREDIT_TRANSACTION:
      return updatedCredits(state, action);
    case ADD_CREDIT_TRANSACTION:
      return addCredit(state, action);
    case RESET_CREDIT_REDUCER:
      return initialState;
    default:
      return state;
  }
};

const addCredit = (state, action) => {
  const { transaction, isLoading, hasUpdate } = action.data;
  if (transaction) {
    return {
      ...state,
      isLoading,
      hasUpdate,
      transactions: [transaction, ...state.transactions]
    };
  }
  return { ...state, ...action.data };
};
const updatedCredits = (state, action) => {
  const { transaction, ...rest } = action.data;
  if (transaction) {
    const { index, status, ...restTransactionData } = transaction;
    const content =
      state.transactions[index] && state.transactions[index].content;

    return {
      ...state,
      transactions: updateItemInItems(state.transactions, index, {
        status,
        content: { ...content, ...restTransactionData }
      }),
      ...rest
    };
  }
  return { ...state, ...action.data };
};

export default transactionReducer;
